exports.isMobile = (data, req) => {
  return new Promise((resolve, rejected) => {
    try {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobile = /iphone|ipod|ipad|android|blackberry|windows phone/.test(
        userAgent
      );
      resolve(isMobile);
    } catch (error) {
      resolve("isMobile", error);
    }
  });
};

exports.getBrowserInfo = (data, req) => {
  return new Promise((resolve, rejected) => {
    try {
      const userAgent = navigator.userAgent;

      let browserName = "";

      // Detectar el nombre del navegador
      if (userAgent.indexOf("Firefox") !== -1) {
        browserName = "Mozilla Firefox";
      } else if (
        userAgent.indexOf("Opera") !== -1 ||
        userAgent.indexOf("OPR") !== -1
      ) {
        browserName = "Opera";
      } else if (userAgent.indexOf("Trident") !== -1) {
        browserName = "Microsoft Internet Explorer";
      } else if (userAgent.indexOf("Edge") !== -1 || 
        userAgent.indexOf("Edg") !== -1) {
        browserName = "Microsoft Edge";
      } else if (userAgent.indexOf("Chrome") !== -1) {
        browserName = "Google Chrome";
      } else if (userAgent.indexOf("Safari") !== -1) {
        browserName = "Apple Safari";
      } else {
        browserName = "unknown";
      }
      // Detectar la versión del navegador
      // if (/version\/([\d.]+)/i.test(userAgent)) {
      //   browserVersion = userAgent.match(/version\/([\d.]+)/i)[1];
      // } else if (userAgent.indexOf("Firefox") !== -1) {
      //   browserVersion = userAgent.match(/Firefox\/([\d.]+)/i)[1];
      // } else if (
      //   userAgent.indexOf("Opera") !== -1 ||
      //   userAgent.indexOf("OPR") !== -1
      // ) {
      //   browserVersion = userAgent.match(/(Opera|OPR)\/([\d.]+)/i)[2];
      // } else if (userAgent.indexOf("Trident") !== -1) {
      //   browserVersion = userAgent.match(/rv:([\d.]+)/i)[1];
      // } else if (userAgent.indexOf("Edge") !== -1) {
      //   browserVersion = userAgent.match(/Edge\/([\d.]+)/i)[1];
      // } else if (userAgent.indexOf("Chrome") !== -1) {
      //   browserVersion = userAgent.match(/Chrome\/([\d.]+)/i)[1];
      // } else if (userAgent.indexOf("Safari") !== -1) {
      //   browserVersion = userAgent.match(/Version\/([\d.]+)/i)[1];
      // }

      resolve({
        name: browserName,
        // version: browserVersion,
      });
    } catch (error) {
      console.log("getBrowserInfo", error);
      resolve("getBrowserInfo", error);
    }
  });
};

